export default __webpack_public_path__ + "static/media/contacto768px.74864371.jpg";